// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/insightsDiscovery/insightsDiscovery.css */

.id-container {
  display: flex;
  height: 100%;
  padding-top: 40px;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ---- Sidebar (run list + annotation list) ---- */
.id-sidebar {
  width: 320px;
  min-width: 260px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f9f9fb;
}

.id-sidebar-section {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.id-sidebar-section + .id-sidebar-section {
  border-top: 1px solid #e0e0e0;
  flex: 2;
}

.id-sidebar-header {
  padding: 12px 16px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.id-model-selector {
  padding: 8px 12px;
  border-bottom: 1px solid #e0e4ec;
  background: #f5f7fb;
}

.id-model-select {
  width: 100%;
  font-size: 12px;
  padding: 4px 6px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  background: #fff;
  color: #333;
  cursor: pointer;
}

.id-run-model-tag {
  font-size: 10px;
  font-weight: 600;
  color: #2e5ca6;
  background: #e8effa;
  border-radius: 3px;
  padding: 1px 5px;
  margin-top: 3px;
  display: inline-block;
  letter-spacing: 0.02em;
}

.id-run-list {
  overflow-y: auto;
  flex: 1;
}

.id-run-item {
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;
  transition: background 0.15s;
}

.id-run-item:hover {
  background: #eef2f8;
}

.id-run-item.active {
  background: #dde8f8;
  border-left: 3px solid #2e5ca6;
}

.id-run-date {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.id-run-time {
  font-size: 11px;
  font-weight: 400;
  color: #777;
}

.id-run-meta {
  display: flex;
  gap: 8px;
  margin-top: 3px;
  font-size: 11px;
  color: #777;
}

.id-run-score {
  font-weight: 600;
  color: #2e5ca6;
}

.id-annotation-list {
  overflow-y: auto;
  flex: 1;
}

.id-annotation-item {
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;
  transition: background 0.15s;
}

.id-annotation-item:hover {
  background: #eef2f8;
}

.id-annotation-item.active {
  background: #dde8f8;
  border-left: 3px solid #2e5ca6;
}

.id-annotation-question {
  font-size: 12px;
  color: #333;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.id-annotation-category {
  margin-top: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.id-annotation-category.findings { color: #1a7a43; }
.id-annotation-category.data-points { color: #2e5ca6; }
.id-annotation-category.methodology { color: #7a4a1a; }
.id-annotation-category.follow-ups { color: #7a1a7a; }

/* ---- Main content area ---- */
.id-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.id-content-header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.id-content-header-text {
  flex: 1;
  min-width: 0;
}

.id-content-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 4px;
}

.id-content-subtitle {
  font-size: 12px;
  color: #777;
}

.id-download-docx-btn {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
  color: #2e5ca6;
  background: #e8effa;
  border: 1px solid #c0d0ed;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  align-self: center;
}

.id-download-docx-btn:hover {
  background: #d0e0f5;
  color: #1a3a7a;
}

.id-content-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* ---- Query result panel ---- */
.id-query-panel {
  margin-bottom: 20px;
}

.id-query-question {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
  padding: 12px 16px;
  background: #f0f4fc;
  border-radius: 6px;
  border-left: 3px solid #2e5ca6;
}

.id-run-btn {
  padding: 8px 20px;
  background: #2e5ca6;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.2s;
  margin-bottom: 16px;
}

.id-run-btn:hover:not(:disabled) {
  background: #1e4080;
}

.id-run-btn:disabled {
  background: #a0b0cc;
  cursor: not-allowed;
}

.id-sql-block {
  margin-bottom: 16px;
}

.id-sql-toggle {
  font-size: 12px;
  color: #2e5ca6;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  user-select: none;
}

.id-sql-code {
  background: #1e2030;
  color: #abb2bf;
  padding: 12px 16px;
  border-radius: 6px;
  font-family: "Fira Mono", "Consolas", monospace;
  font-size: 12px;
  white-space: pre-wrap;
  overflow-x: auto;
}

.id-result-meta {
  font-size: 11px;
  color: #888;
  margin-bottom: 8px;
}

.id-error-box {
  padding: 12px 16px;
  background: #fff0f0;
  border: 1px solid #ffb0b0;
  border-radius: 6px;
  color: #c00;
  font-size: 13px;
}

.id-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
  font-size: 14px;
  text-align: center;
}

/* ---- Synthesis panel ---- */
.id-synthesis-section {
  margin-top: 20px;
}

.id-synthesis-toggle {
  font-size: 13px;
  font-weight: 600;
  color: #2e5ca6;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  padding: 8px 0;
  border-top: 1px solid #e0e0e0;
}

.id-synthesis-body {
  padding: 12px 0;
  font-size: 13px;
  line-height: 1.7;
  color: #333;
}

.id-loading-text {
  color: #888;
  font-size: 13px;
  padding: 12px 0;
}

/* ---- Citation superscripts in synthesis text ---- */
.id-citation-ref {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: #2e5ca6;
  color: #fff;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  line-height: 1;
  vertical-align: super;
  transition: background 0.15s;
  text-decoration: none;
}
.id-citation-ref:hover {
  background: #1e4080;
}

/* ---- Inline citation expandable box (like thinking box) ---- */
.id-citation-wrapper {
  display: inline-block;
  vertical-align: top;
  position: relative;
}

.id-inline-citation-box {
  display: block;
  margin: 6px 0 8px 0;
  border: 1px solid #d0d8e8;
  border-radius: 8px;
  background-color: #f4f6fb;
  overflow: hidden;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
}

.id-inline-citation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}
.id-inline-citation-header:hover {
  background-color: #e6eaf4;
}

.id-inline-citation-label {
  font-size: 13px;
  font-weight: 500;
  color: #2e4a7a;
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 12px;
}

.id-inline-citation-toggle {
  background: transparent;
  border: 1px solid #a0b4d4;
  border-radius: 4px;
  padding: 3px 10px;
  cursor: pointer;
  font-size: 12px;
  color: #2e5ca6;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
}
.id-inline-citation-toggle:hover {
  background-color: #dde8f8;
  border-color: #2e5ca6;
}

.id-inline-citation-content {
  display: block;
  padding: 10px 14px 12px;
  border-top: 1px solid #d0d8e8;
  background-color: #ffffff;
}

.id-inline-citation-preview {
  display: block;
  font-size: 12px;
  color: #444;
  line-height: 1.6;
  margin-bottom: 10px;
  max-height: 240px;
  overflow-y: auto;
}

.id-inline-citation-run-btn {
  display: inline-block;
  background: #2e5ca6;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 10px;
}
.id-inline-citation-run-btn:hover:not(:disabled) {
  background: #1e4080;
}
.id-inline-citation-run-btn:disabled {
  background: #9aa5b4;
  cursor: default;
}

.id-inline-citation-loading {
  display: block;
  font-size: 12px;
  color: #777;
  font-style: italic;
  padding: 8px 0;
}

.id-inline-citation-error {
  display: block;
  font-size: 12px;
  color: #c0392b;
  padding: 6px 0;
}

.id-inline-citation-interp-section {
  display: block;
  margin-bottom: 8px;
}

.id-inline-citation-interp-toggle {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #2e5ca6;
  cursor: pointer;
  user-select: none;
  padding: 4px 0;
}
.id-inline-citation-interp-toggle:hover {
  color: #1e4080;
}

.id-inline-citation-interp-body {
  display: block;
  font-size: 12px;
  color: #555;
  line-height: 1.6;
  padding: 6px 0 4px 12px;
  border-left: 2px solid #d0d8e8;
  margin-top: 4px;
}

.id-inline-citation-narrative {
  display: block;
  font-size: 12px;
  color: #444;
  line-height: 1.6;
  padding: 6px 0 4px 12px;
  border-left: 2px solid #d0d8e8;
  margin-top: 4px;
}

.id-inline-result-meta {
  display: block;
  font-size: 11px;
  color: #888;
  margin-bottom: 6px;
}

.id-inline-citation-derived-note {
  display: block;
  font-size: 11px;
  font-style: italic;
  color: #999;
  margin-top: 6px;
}

.id-inline-grid-wrapper {
  display: block;
}

.id-preview-text {
  font-size: 12px;
  color: #777;
  font-style: italic;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ---- Feedback bar ---- */
.id-feedback {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.id-feedback-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.id-feedback-label {
  font-size: 13px;
  color: #666;
  margin-right: 4px;
}

.id-feedback-btn {
  background: transparent;
  border: none;
  border-radius: 999px;
  padding: 4px;
  cursor: pointer;
  transition: background 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  min-height: 26px;
}

.id-feedback-btn:hover:not(:disabled) {
  background: rgba(46, 92, 166, 0.1);
}

.id-feedback-btn.active {
  background: rgba(46, 92, 166, 0.15);
}

.id-feedback-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.id-feedback-thanks {
  font-size: 12px;
  color: #1a7a43;
  font-weight: 500;
}

.id-feedback-error {
  font-size: 12px;
  color: #c00;
}

.id-feedback-text-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.id-feedback-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
  box-sizing: border-box;
}

.id-feedback-textarea:focus {
  outline: none;
  border-color: #2e5ca6;
}

.id-feedback-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.id-feedback-submit {
  background: #2e5ca6;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}

.id-feedback-submit:hover:not(:disabled) {
  background: #1e4080;
}

.id-feedback-submit:disabled {
  opacity: 0.6;
  cursor: default;
}

.id-feedback-cancel {
  background: transparent;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 16px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.id-feedback-cancel:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #999;
}

`, "",{"version":3,"sources":["webpack://./src/components/insightsDiscovery/insightsDiscovery.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mCAAmC,cAAc,EAAE;AACnD,sCAAsC,cAAc,EAAE;AACtD,sCAAsC,cAAc,EAAE;AACtD,qCAAqC,cAAc,EAAE;;AAErD,gCAAgC;AAChC;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* src/components/insightsDiscovery/insightsDiscovery.css */\n\n.id-container {\n  display: flex;\n  height: 100%;\n  padding-top: 40px;\n  overflow: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* ---- Sidebar (run list + annotation list) ---- */\n.id-sidebar {\n  width: 320px;\n  min-width: 260px;\n  border-right: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #f9f9fb;\n}\n\n.id-sidebar-section {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.id-sidebar-section + .id-sidebar-section {\n  border-top: 1px solid #e0e0e0;\n  flex: 2;\n}\n\n.id-sidebar-header {\n  padding: 12px 16px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #666;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.id-model-selector {\n  padding: 8px 12px;\n  border-bottom: 1px solid #e0e4ec;\n  background: #f5f7fb;\n}\n\n.id-model-select {\n  width: 100%;\n  font-size: 12px;\n  padding: 4px 6px;\n  border: 1px solid #d0d7de;\n  border-radius: 4px;\n  background: #fff;\n  color: #333;\n  cursor: pointer;\n}\n\n.id-run-model-tag {\n  font-size: 10px;\n  font-weight: 600;\n  color: #2e5ca6;\n  background: #e8effa;\n  border-radius: 3px;\n  padding: 1px 5px;\n  margin-top: 3px;\n  display: inline-block;\n  letter-spacing: 0.02em;\n}\n\n.id-run-list {\n  overflow-y: auto;\n  flex: 1;\n}\n\n.id-run-item {\n  padding: 10px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #ebebeb;\n  transition: background 0.15s;\n}\n\n.id-run-item:hover {\n  background: #eef2f8;\n}\n\n.id-run-item.active {\n  background: #dde8f8;\n  border-left: 3px solid #2e5ca6;\n}\n\n.id-run-date {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.id-run-time {\n  font-size: 11px;\n  font-weight: 400;\n  color: #777;\n}\n\n.id-run-meta {\n  display: flex;\n  gap: 8px;\n  margin-top: 3px;\n  font-size: 11px;\n  color: #777;\n}\n\n.id-run-score {\n  font-weight: 600;\n  color: #2e5ca6;\n}\n\n.id-annotation-list {\n  overflow-y: auto;\n  flex: 1;\n}\n\n.id-annotation-item {\n  padding: 10px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #ebebeb;\n  transition: background 0.15s;\n}\n\n.id-annotation-item:hover {\n  background: #eef2f8;\n}\n\n.id-annotation-item.active {\n  background: #dde8f8;\n  border-left: 3px solid #2e5ca6;\n}\n\n.id-annotation-question {\n  font-size: 12px;\n  color: #333;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.id-annotation-category {\n  margin-top: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.id-annotation-category.findings { color: #1a7a43; }\n.id-annotation-category.data-points { color: #2e5ca6; }\n.id-annotation-category.methodology { color: #7a4a1a; }\n.id-annotation-category.follow-ups { color: #7a1a7a; }\n\n/* ---- Main content area ---- */\n.id-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.id-content-header {\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.id-content-header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.id-content-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin: 0 0 4px;\n}\n\n.id-content-subtitle {\n  font-size: 12px;\n  color: #777;\n}\n\n.id-download-docx-btn {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #2e5ca6;\n  background: #e8effa;\n  border: 1px solid #c0d0ed;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n  align-self: center;\n}\n\n.id-download-docx-btn:hover {\n  background: #d0e0f5;\n  color: #1a3a7a;\n}\n\n.id-content-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n/* ---- Query result panel ---- */\n.id-query-panel {\n  margin-bottom: 20px;\n}\n\n.id-query-question {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin-bottom: 12px;\n  padding: 12px 16px;\n  background: #f0f4fc;\n  border-radius: 6px;\n  border-left: 3px solid #2e5ca6;\n}\n\n.id-run-btn {\n  padding: 8px 20px;\n  background: #2e5ca6;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background 0.2s;\n  margin-bottom: 16px;\n}\n\n.id-run-btn:hover:not(:disabled) {\n  background: #1e4080;\n}\n\n.id-run-btn:disabled {\n  background: #a0b0cc;\n  cursor: not-allowed;\n}\n\n.id-sql-block {\n  margin-bottom: 16px;\n}\n\n.id-sql-toggle {\n  font-size: 12px;\n  color: #2e5ca6;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 6px;\n  user-select: none;\n}\n\n.id-sql-code {\n  background: #1e2030;\n  color: #abb2bf;\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-family: \"Fira Mono\", \"Consolas\", monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  overflow-x: auto;\n}\n\n.id-result-meta {\n  font-size: 11px;\n  color: #888;\n  margin-bottom: 8px;\n}\n\n.id-error-box {\n  padding: 12px 16px;\n  background: #fff0f0;\n  border: 1px solid #ffb0b0;\n  border-radius: 6px;\n  color: #c00;\n  font-size: 13px;\n}\n\n.id-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #999;\n  font-size: 14px;\n  text-align: center;\n}\n\n/* ---- Synthesis panel ---- */\n.id-synthesis-section {\n  margin-top: 20px;\n}\n\n.id-synthesis-toggle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2e5ca6;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  user-select: none;\n  padding: 8px 0;\n  border-top: 1px solid #e0e0e0;\n}\n\n.id-synthesis-body {\n  padding: 12px 0;\n  font-size: 13px;\n  line-height: 1.7;\n  color: #333;\n}\n\n.id-loading-text {\n  color: #888;\n  font-size: 13px;\n  padding: 12px 0;\n}\n\n/* ---- Citation superscripts in synthesis text ---- */\n.id-citation-ref {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  background: #2e5ca6;\n  color: #fff;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: pointer;\n  line-height: 1;\n  vertical-align: super;\n  transition: background 0.15s;\n  text-decoration: none;\n}\n.id-citation-ref:hover {\n  background: #1e4080;\n}\n\n/* ---- Inline citation expandable box (like thinking box) ---- */\n.id-citation-wrapper {\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n}\n\n.id-inline-citation-box {\n  display: block;\n  margin: 6px 0 8px 0;\n  border: 1px solid #d0d8e8;\n  border-radius: 8px;\n  background-color: #f4f6fb;\n  overflow: hidden;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: normal;\n}\n\n.id-inline-citation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n.id-inline-citation-header:hover {\n  background-color: #e6eaf4;\n}\n\n.id-inline-citation-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #2e4a7a;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  margin-right: 12px;\n}\n\n.id-inline-citation-toggle {\n  background: transparent;\n  border: 1px solid #a0b4d4;\n  border-radius: 4px;\n  padding: 3px 10px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #2e5ca6;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.id-inline-citation-toggle:hover {\n  background-color: #dde8f8;\n  border-color: #2e5ca6;\n}\n\n.id-inline-citation-content {\n  display: block;\n  padding: 10px 14px 12px;\n  border-top: 1px solid #d0d8e8;\n  background-color: #ffffff;\n}\n\n.id-inline-citation-preview {\n  display: block;\n  font-size: 12px;\n  color: #444;\n  line-height: 1.6;\n  margin-bottom: 10px;\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.id-inline-citation-run-btn {\n  display: inline-block;\n  background: #2e5ca6;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 10px;\n}\n.id-inline-citation-run-btn:hover:not(:disabled) {\n  background: #1e4080;\n}\n.id-inline-citation-run-btn:disabled {\n  background: #9aa5b4;\n  cursor: default;\n}\n\n.id-inline-citation-loading {\n  display: block;\n  font-size: 12px;\n  color: #777;\n  font-style: italic;\n  padding: 8px 0;\n}\n\n.id-inline-citation-error {\n  display: block;\n  font-size: 12px;\n  color: #c0392b;\n  padding: 6px 0;\n}\n\n.id-inline-citation-interp-section {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.id-inline-citation-interp-toggle {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #2e5ca6;\n  cursor: pointer;\n  user-select: none;\n  padding: 4px 0;\n}\n.id-inline-citation-interp-toggle:hover {\n  color: #1e4080;\n}\n\n.id-inline-citation-interp-body {\n  display: block;\n  font-size: 12px;\n  color: #555;\n  line-height: 1.6;\n  padding: 6px 0 4px 12px;\n  border-left: 2px solid #d0d8e8;\n  margin-top: 4px;\n}\n\n.id-inline-citation-narrative {\n  display: block;\n  font-size: 12px;\n  color: #444;\n  line-height: 1.6;\n  padding: 6px 0 4px 12px;\n  border-left: 2px solid #d0d8e8;\n  margin-top: 4px;\n}\n\n.id-inline-result-meta {\n  display: block;\n  font-size: 11px;\n  color: #888;\n  margin-bottom: 6px;\n}\n\n.id-inline-citation-derived-note {\n  display: block;\n  font-size: 11px;\n  font-style: italic;\n  color: #999;\n  margin-top: 6px;\n}\n\n.id-inline-grid-wrapper {\n  display: block;\n}\n\n.id-preview-text {\n  font-size: 12px;\n  color: #777;\n  font-style: italic;\n  margin-top: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ---- Feedback bar ---- */\n.id-feedback {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.id-feedback-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.id-feedback-label {\n  font-size: 13px;\n  color: #666;\n  margin-right: 4px;\n}\n\n.id-feedback-btn {\n  background: transparent;\n  border: none;\n  border-radius: 999px;\n  padding: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  min-height: 26px;\n}\n\n.id-feedback-btn:hover:not(:disabled) {\n  background: rgba(46, 92, 166, 0.1);\n}\n\n.id-feedback-btn.active {\n  background: rgba(46, 92, 166, 0.15);\n}\n\n.id-feedback-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.id-feedback-thanks {\n  font-size: 12px;\n  color: #1a7a43;\n  font-weight: 500;\n}\n\n.id-feedback-error {\n  font-size: 12px;\n  color: #c00;\n}\n\n.id-feedback-text-container {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.id-feedback-textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.id-feedback-textarea:focus {\n  outline: none;\n  border-color: #2e5ca6;\n}\n\n.id-feedback-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.id-feedback-submit {\n  background: #2e5ca6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.id-feedback-submit:hover:not(:disabled) {\n  background: #1e4080;\n}\n\n.id-feedback-submit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.id-feedback-cancel {\n  background: transparent;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.id-feedback-cancel:hover:not(:disabled) {\n  background: #f5f5f5;\n  border-color: #999;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
